import { useUserStore } from 'store/modules';

export default function (to, from, next) {
    const userStore = useUserStore();

    if (to?.query?.redirect && userStore.isLoggedIn) {
        const redirect = decodeURIComponent(to.query.redirect).replace(location.origin, '');
        const isAuth = redirect.includes('auth/oauth');

        if (isAuth) {
            next(redirect);

            return;
        }
    }

    if (to.matched.some((record) => record.meta.auth) && !userStore.isLoggedIn) {
        if (!userStore.hasOid) {
            window.location.href = '/auth/login';
            return;
        }

        next({
            name: 'auth.login',
            query: { redirect: to.fullPath },
        });
    } else {
        next();
    }
}
